// Uncomment the below to migrate to statefull component
// import ContentContainer from './ContentContainer'
import CrossStorage from './CrossStorage'

export { CrossStorage }
export default CrossStorage
// Uncomment the below to migrate to statefull component
// export { ContentContainer }
// export default { ContentContainer }



// WEBPACK FOOTER //
// ./src/pages/CrossStorage/index.js